export default __webpack_public_path__ + "static/media/layer-waypoint.54a80776.svg";